import { PATH } from 'constants/path';
import Link from 'next/link';
import React from 'react';
import { ITagSummary } from 'types/cms';

import styles from './style.module.scss';

interface IProps {
  tags: ITagSummary[];
}

export const ArticleTags: React.FC<IProps> = ({ tags }) => {
  return (
    <div className={styles.container}>
      {tags.map(tag => {
        return (
          <Link
            prefetch={false}
            key={tag.id}
            href={`${PATH.ARTICLE_TAG}/${tag.slug}`}
            as={`${PATH.ARTICLE_TAG}/${tag.slug}`}
          >
            <a href={`${PATH.ARTICLE_TAG}/${tag.slug}`}>
              <div className={styles.tag}>#{tag.name}</div>
            </a>
          </Link>
        );
      })}
    </div>
  );
};
